module.exports = __webpack_public_path__ + "static/media/85x11no3.38fe48bd.jpg";